import { all, call, put, takeLatest } from 'redux-saga/effects';
import { api } from '~/services/api';
import { ResponseProps } from '../../../propsGlobal/responseProps';
import {
  documentsFailure,
  documentsRequest,
  documentsSuccess,
} from './actions';
import { DocumentTypes } from './types';

function* documents({ payload }: ReturnType<typeof documentsRequest>) {
  const { company } = payload;

  try {
    const response: ResponseProps = yield call(api.get, 'v1/pages', {
      headers: {
        company: company,
        Authorization: '',
      },
    });

    const slugify = (text: string) => {
      return text
        .toString()
        .toLowerCase()
        .normalize('NFD')
        .trim()
        .replace(/\s+/g, '-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-');
    };

    const data = response.data.map((el: any) => {
      return {
        ...el,
        slug: slugify(el.page_nm),
      };
    });

    yield put(documentsSuccess(data));
  } catch (error) {
    yield put(documentsFailure());
  }
}

export default all([takeLatest(DocumentTypes.DOCUMENTS_RESQUEST, documents)]);
